import React, { useState, useEffect } from "react";
import { Button, Input } from "reactstrap";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { resetPassword, passwordExpired } from "../../../context/actions/user";
import { resetPasswordSchema, resetPasswordInit } from "./schema";
import TextInput from "../../common/FormsInput/FormInput";
import Head from "../Head";
import "./../SignupModule.scss";
import { useParams, useHistory } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import { forgotPassword } from "../../../context/actions/user";
import Swal from "sweetalert2";
const MySwal = withReactContent(Swal);

toast.configure();

const ResetPassword = () => {
  let { passwordtoken } = useParams();
  let history = useHistory();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  /**
   * @description method call to submit valid form
   * @param {Object} params form params
   * @param {Instance} status form status
   */
  const submitForm = async (params) => {
    setDisabled(true);
    params.passwordtoken = passwordtoken;
    dispatch(
      resetPassword(params, (result) => {
        setDisabled(false);
        if (result) {
          history.push("/login");
        }
      })
    );
  };

  useEffect(() => {
    let params = {};
    params.passwordtoken = passwordtoken;
    dispatch(
      passwordExpired(params, (res) => {
        if (res?.errors) {
          if (res?.errors?.email) {
            MySwal.fire({
              title: "Link Expired",
              text: "Your Password Reset Link has been expired. Please Click on Resend Button to get the new Reset Link on Email",
              icon: "warning",
              allowOutsideClick: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Resend",
            }).then((result) => {
              if (result.isConfirmed) {
                dispatch(
                  forgotPassword({ email: res?.errors?.email }, (response) => {
                    if (response) {
                      history.push("/login");
                    }
                  })
                );
              }
            });
          } else {
            if (res?.errors?.msg == "PASSWORD EXPIRE") {
              MySwal.fire({
                title: "Link Expired",
                text: "Your Password Reset Link is No Longer Valid",
                icon: "warning",
                allowOutsideClick: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Okay",
              }).then((result) => {
                if (result.isConfirmed) {
                  history.push("/login");
                }
              });
            } else {
              MySwal.fire({
                title: "Password Already Reset",
                text: "You have already reset your password",
                icon: "warning",
                allowOutsideClick: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Okay",
              }).then((result) => {
                if (result.isConfirmed) {
                  history.push("/login");
                }
              });
            }
          }
        }
      })
    );
  }, []);

  return (
    <div className={`login-blc m-auto signup-box`}>
      <Head heading="Reset Password" />
      <Formik
        initialValues={resetPasswordInit}
        enableReinitialize
        validationSchema={resetPasswordSchema}
        onSubmit={submitForm}
      >
        {(formik) => (
          <Form>
            <TextInput
              name="password"
              type="password"
              placeholder="Enter your password"
              id="newPassword"
              value={formik?.values?.password}
              isRequired={true}
              label="Password"
              onChange={formik.handleChange}
              passwordHint
            />
            <TextInput
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              id="confirmPassword"
              label="Confirm Password"
              isRequired={true}
              value={formik?.values?.confirmPassword}
              onChange={formik.handleChange}
            />
            <div className="btn-cell d-flex">
              <Button disabled={disabled} className="flex-fill" color="primary">
                Reset Password
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassword;
